import { createSlice } from '@reduxjs/toolkit';

const loadInitialSelectedChild = () => {
  const savedId = localStorage.getItem('parentSelectedChildId');
  return savedId ? Number(savedId) : null;
};

const normalizeId = (id) =>
  id === undefined || id === null ? id : Number(id);

const parentSelectedChildIdSlice = createSlice({
  name: 'parentSelectedChildId',
  initialState: loadInitialSelectedChild(),
  reducers: {
    setParentSelectedChild: (state, action) => {
      const childId = normalizeId(action.payload);
      if (childId === undefined || childId === null) {
        localStorage.removeItem('parentSelectedChildId');
        return null;
      } 
      else {
        localStorage.setItem('parentSelectedChildId', childId);
        return childId;
      }
    }
  },
  extraReducers: (builder) => {
    // Автоматически выбираем первого ребёнка при загрузке профиля
    builder.addMatcher(
      (action) => action.type === 'impulse/profile/UPD_USER_PROFILE',
      (state, {profile}) => {
        if (!Object.prototype.hasOwnProperty.call(profile ?? {}, 'children')) {
          return state;
        }

        if (state !== null) {
          const childExists = profile.children?.some(
            child => normalizeId(child.id) === normalizeId(state)
          );
          if (!childExists) {
            localStorage.removeItem('parentSelectedChildId');
            return null;
          }
          return state;
        }
        
        // Выбираем первого ребёнка (если есть)
        const sortedChildren = sortChildrenByName(profile.children);
        return normalizeId(sortedChildren[0]?.id) ?? null;
      }
    );
  }
});

export const { setParentSelectedChild } = parentSelectedChildIdSlice.actions;
export default parentSelectedChildIdSlice.reducer;


// Функция для сортировки учеников по имени
const sortChildrenByName = (children) => {
  if (!children) return [];
  
  return [...children].sort((a, b) => 
    (a.name ?? '').toLowerCase().localeCompare((b.name ?? '').toLowerCase())
  );
};
